import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

function SEO() {
  const location = useLocation();
  const pathname = location.pathname;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "6G AI Sweden AB",
    "url": "https://6gai.se",
    "logo": "https://6gai.se/logo.png",
    "description": "World-class sovereign AI cloud infrastructure in Sweden. Powered by NVIDIA H200 and GB300 GPUs. GDPR compliant, ISO 27001 certified.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Stockholm",
      "addressRegion": "Stockholm",
      "addressCountry": "SE"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "sales",
      "email": "info@6gai.se"
    },
    "sameAs": [
      "https://www.linkedin.com/company/6g-digital-sweden-ab/",
      "https://x.com/6gaisweden"
    ]
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://6gai.se/"
      }
    ]
  };

  if (pathname === '/services') {
    breadcrumbSchema.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": "Services",
      "item": "https://6gai.se/services"
    });
  } else if (pathname === '/infrastructure') {
    breadcrumbSchema.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": "Infrastructure",
      "item": "https://6gai.se/infrastructure"
    });
  } else if (pathname === '/about') {
    breadcrumbSchema.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": "About",
      "item": "https://6gai.se/about"
    });
  } else if (pathname === '/contact') {
    breadcrumbSchema.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": "Contact",
      "item": "https://6gai.se/contact"
    });
  } else if (pathname === '/news') {
    breadcrumbSchema.itemListElement.push({
      "@type": "ListItem",
      "position": 2,
      "name": "News",
      "item": "https://6gai.se/news"
    });
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>
    </Helmet>
  );
}

export default SEO;